module.exports = __webpack_public_path__ + "static/media/2024_composite.ae903dad.jpg";